import React, { useEffect, useState } from 'react';
import PieChart, { Legend, Series, Tooltip, Size, Export, Label, Connector } from 'devextreme-react/pie-chart';
import { RingChart } from './RingChart';
import { baseRequest } from '../../fetch/basicThunk';
import { useDispatch } from 'react-redux';
import { QUERY_GET_AGENT_KPI, QUERY_GET_CASE_KPI } from '../../fetch/constantQueries';
import { KpiTable } from './KpiTable';
import { Column } from 'devextreme-react/data-grid';
import { openModal } from '../../redux/modal/modalSlice';
import { PanelHeader } from './PanelHeader';

function Dashboard() {
  const [caseData, setCaseData] = useState({
    casesByCategory: [
      { type: 'Categorizados', value: '-' },
      { type: 'Sem categorizar', value: '-' },
    ],
    casesByTaxonomy: [],
    totalCases: '-',
    taxonomyCount: '-',
    uncategorizedCases: [],
  });
  const [agentData, setAgentData] = useState({
    agentsByAvaliability: [],
    agentsByAllocation: [
      { type: 'Designados', value: '-' },
      { type: 'Sem designar', value: '-' },
    ],
    activeAgentsCount: '-',
    avaliableAgents: [],
    unavaliableAgents: [],
    avaliableAgentsCount: '-',
    unavaliableAgentsCount: '-',
  });
  const [loadingCaseData, setLoadingCaseData] = useState(true);
  const [loadingAgentData, setLoadingAgentData] = useState(true);
  const dispatch = useDispatch();

  const chartByChannels = [
    {
      type: 'Telefone',
      value: 12,
    },
    {
      type: 'E-mail',
      value: 7,
    },
    {
      type: 'Whatsapp',
      value: 3,
    },
  ];

const chartByStates = [
    {
      type: 'Encerrado',
      value: 12,
    },
    {
      type: 'Pendente',
      value: 7,
    },
    {
      type: 'Em andamento',
      value: 3,
    },
    {
      type: 'Em análise',
      value: 3,
    },
    {
      type: 'Backoffice',
      value: 3,
    },
    {
      type: 'Em aprvação',
      value: 3,
    }
  ];

  function pointClickHandler(e) {
    toggleVisibility(e.target);
  }
  function legendClickHandler(e) {
    const arg = e.target;
    const item = e.component.getAllSeries()[0].getPointsByArg(arg)[0];
    toggleVisibility(item);
  }
  function toggleVisibility(item) {
    item.isVisible() ? item.hide() : item.show();
  }

  useEffect(() => {
    getCaseKpiData();
    getAgentsKpiData();
  }, []);

  function customizeTooltip(arg) {
    return {
      text: `${arg.argumentText.trim() === '' ? 'SEM TAXONOMIZAR' : arg.argumentText} : ${arg.value}`,
    };
  }

  async function getCaseKpiData() {
    try {
      const data = await baseRequest(null, dispatch, QUERY_GET_CASE_KPI, 'GET');
      const casesByCategory = [
        { type: 'Em andamento', value: data.categorizedCases },
        { type: 'Novos', value: data.uncategorizedCasesCount },
        { type: 'Encerrados', value: data.endedCasesCount },
      ];
      const casesByTaxonomy = [...data.taxonomies];

      const casesByEntryChannel = [...data.entryChannels];
      const casesByState = [...data.states];

      const transformedData = {
        casesByCategory,
        casesByTaxonomy,
        uncategorizedCasesCount: data.uncategorizedCasesCount,
        uncategorizedCases: data.uncategorizedCases,
        totalCases: data.totalCases,
        cases: data.cases,
        taxonomyCount: data.taxonomyCount,
        
        casesByEntryChannel,
        entryChannelCount: data.entryChannelCount,
        
        casesByState,
        stateCount: data.stateCount,
      };

      setCaseData(transformedData);
      setLoadingCaseData(false);
    } catch (error) {
      dispatch(openModal({ type: 'warning', message: 'Não foi possível obter métricas de casos' }));
    }
  }

  async function getAgentsKpiData() {
    try {
      const data = await baseRequest(null, dispatch, QUERY_GET_AGENT_KPI, 'GET');
      const agentsByAvaliability = [
        { type: 'Disponíveis', value: data.avaliableAgentsCount },
        { type: 'Indisponíveis', value: data.unavaliableAgentsCount },
      ];
      const agentsByAllocation = [
        { type: 'Designados', value: data.allocatedAgents },
        { type: 'Sem designar', value: data.unAllocatedAgents },
      ];
      const transformedData = {
        agentsByAvaliability,
        agentsByAllocation,
        avaliableAgents: data.avaliableAgents,
        unavaliableAgents: data.unavaliableAgents,
        avaliableAgentsCount: data.avaliableAgentsCount,
        unavaliableAgentsCount: data.unavaliableAgentsCount,
        activeAgents: data.activeAgents,
      };

      setAgentData(transformedData);
      setLoadingAgentData(false);
    } catch (error) {
      dispatch(openModal({ type: 'warning', message: 'Não foi possível obter métricas dos agentes' }));
    }
  }

  const caseColumns = [
    <Column key={'case-1'} caption={'Agente'} width={'10%'} dataField={'agent'} dataType={'string'} />,
    <Column key={'case-2'} caption={'Id'} width={'15%'} dataField={'caseId'} dataType={'string'} />,
    <Column key={'case-3'} caption={'Cliente'} dataField={'customerName'} dataType={'string'} />,
    <Column key={'case-4'} caption={'Data de criação'} width={'15%'} dataField={'creationDate'} dataType={'date'} />,
    <Column key={'case-5'} caption={'Data de fechamento'} width={'15%'} dataField={'closeDate'} dataType={'date'} />,
  ];

  const agentColumns = [<Column key={'agent-1'} caption={'Agente'} calculateDisplayValue={(r) => `${r.userId} - ${r.userName}`} dataType={'string'} />];

  // return (
  //   <div className="dashboard-container">
  //     <div className="dashboard-panel">
  //       <PanelHeader title={'Casos abertos:'} value={caseData.totalCases} />
  //       <div className="dashboard-panel-chart-container">
  //         <RingChart datasource={caseData.casesByCategory} palette={['#116864', '#66B8B2']} isLoading={loadingCaseData} />
  //         <div>
  //           <div style={{ display: 'flex', flexDirection: 'column', rowGap: '1.5rem', alignItems: 'center' }}>
  //             <PieChart
  //               id="pie"
  //               loadingIndicator={{ show: loadingCaseData, text: 'Carregando' }}
  //               type="doughnut"
  //               palette={['#001D33', '#004975', '#003253', '#00629A']}
  //               dataSource={caseData.casesByTaxonomy}
  //               startAngle={35}
  //               innerRadius={0.65}
  //             >
  //               <Series argumentField="taxonomyDescription" valueField={'quantity'} hoverStyle={{ hatching: { opacity: 100 } }} />
  //               <Legend visible={false} />
  //               <Tooltip enabled={true} toolt customizeTooltip={customizeTooltip} />
  //               <Size height={225} width={250} />
  //             </PieChart>
  //             <div style={{ display: 'flex', columnGap: '0.25rem' }}>
  //               <div style={{ display: 'grid', gridTemplateRows: '1fr 1fr', textAlign: 'center', alignItems: 'center', justifyContent: 'center' }}>
  //                 <div style={{ fontWeight: 700 }}>{caseData.taxonomyCount}</div>
  //                 <div>{'Taxonomias (selecione para ver)'}</div>
  //               </div>
  //             </div>
  //           </div>
  //         </div>
  //       </div>
  //     </div>
  //     <div className="dashboard-panel">
  //       <PanelHeader title={'Casos sem categorização:'} value={caseData.uncategorizedCasesCount} />
  //       <div style={{ padding: '0 2rem' }}>
  //         <KpiTable dataSource={caseData.uncategorizedCases} showHeaders={true} columns={caseColumns} isLoadingData={loadingCaseData}></KpiTable>
  //       </div>
  //     </div>
  //     <div className="dashboard-panel">
  //       <PanelHeader title={'Agentes disponíveis:'} value={agentData.avaliableAgentsCount} />
  //       <div className="dashboard-panel-chart-container">
  //         <RingChart isLoading={loadingAgentData} datasource={agentData.agentsByAllocation} palette={['#006C3A', '#5EBD82']} />
  //       </div>
  //     </div>
  //     <div className="dashboard-panel" style={{ padding: '0 1rem' }}>
  //       <div>
  //         <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', columnGap: '3rem' }}>
  //           <div>
  //             <PanelHeader title={'Agentes disponíveis:'} value={agentData.avaliableAgentsCount} />
  //             <div style={{ paddingTop: '1rem' }}>
  //               <KpiTable dataSource={agentData.avaliableAgents} showHeaders={false} columns={agentColumns} isLoadingData={loadingAgentData} />
  //             </div>
  //           </div>
  //           <div>
  //             <PanelHeader title={'Agentes indisponíveis:'} value={agentData.unavaliableAgentsCount} />
  //             <div style={{ paddingTop: '1rem' }}>
  //               <KpiTable dataSource={agentData.unavaliableAgents} showHeaders={false} columns={agentColumns} isLoadingData={loadingAgentData} />
  //             </div>
  //           </div>
  //         </div>
  //       </div>
  //     </div>
  //   </div>
  // );

  return (
    <div className="dashboard-container">
      <div className="dashboard-panel">
        <PanelHeader title={'Casos:'} value={caseData.totalCases} />
        <div className="dashboard-panel-chart-container">
          <RingChart datasource={caseData.casesByCategory} palette={['#116864', '#66B8B2']} isLoading={loadingCaseData} />
          <div>
            <div style={{ display: 'flex', flexDirection: 'column', rowGap: '1.5rem', alignItems: 'center' }}>
              <PieChart
                id="pie"
                loadingIndicator={{ show: loadingCaseData, text: 'Carregando' }}
                type="doughnut"
                palette={['#001D33', '#004975', '#003253', '#00629A']}
                dataSource={caseData.casesByTaxonomy}
                startAngle={35}
                innerRadius={0.65}
              >
                <Series argumentField="taxonomyDescription" valueField={'quantity'} hoverStyle={{ hatching: { opacity: 100 } }} />
                <Legend visible={false} />
                <Tooltip enabled={true} toolt customizeTooltip={customizeTooltip} />
                <Size height={225} width={250} />
              </PieChart>
              <div style={{ display: 'flex', columnGap: '0.25rem' }}>
                <div style={{ display: 'grid', gridTemplateRows: '1fr 1fr', textAlign: 'center', alignItems: 'center', justifyContent: 'center' }}>
                  <div style={{ fontWeight: 700 }}>{caseData.taxonomyCount}</div>
                  <div>{'Taxonomias'}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="dashboard-panel">
        <PanelHeader title={'Casos:'} value={caseData.totalCases} />
        <div className="dashboard-panel-chart-container" style={{ padding: '2rem' }}>
          {/* <KpiTable dataSource={caseData.uncategorizedCases} showHeaders={true} columns={caseColumns} isLoadingData={loadingCaseData}></KpiTable> */}

          {/* <PieChart id="pie" dataSource={channels} palette="Office" onPointClick={pointClickHandler} onLegendClick={legendClickHandler}>
            <Series argumentField="country" valueField="area">
              <Label visible={true}>
                <Connector visible={true} width={1} />
              </Label>
            </Series>

            <Size width={500} />
            <Export enabled={true} />
          </PieChart> */}
          <div style={{ display: 'flex', flexDirection: 'column', rowGap: '1.5rem', alignItems: 'center' }}>
            <PieChart
              id="pie"
              loadingIndicator={{ show: loadingCaseData, text: 'Carregando' }}
              type="doughnut"
              palette={['#116864', '#66B8B2']}
              dataSource={caseData.casesByEntryChannel}
              startAngle={35}
              innerRadius={0.65}
            >
              <Series argumentField="description" valueField={'quantity'} hoverStyle={{ hatching: { opacity: 100 } }} />
              <Legend visible={false} />
              <Tooltip enabled={true} toolt customizeTooltip={customizeTooltip} />
              <Size height={225} width={250} />
            </PieChart>
            <div style={{ display: 'flex', columnGap: '0.25rem' }}>
              <div style={{ display: 'grid', gridTemplateRows: '1fr 1fr', textAlign: 'center', alignItems: 'center', justifyContent: 'center' }}>
                <div style={{ fontWeight: 700 }}>{caseData.entryChannelCount}</div>
                <div>{'Canais de entrada'}</div>
              </div>
            </div>
          </div>

          <div style={{ display: 'flex', flexDirection: 'column', rowGap: '1.5rem', alignItems: 'center' }}>
            <PieChart
              id="pie"
              loadingIndicator={{ show: loadingCaseData, text: 'Carregando' }}
              type="doughnut"
              palette={['#001D33', '#004975', '#003253', '#00629A']}
              dataSource={caseData.casesByState}
              startAngle={35}
              innerRadius={0.65}
            >
              <Series argumentField="description" valueField={'quantity'} hoverStyle={{ hatching: { opacity: 100 } }} />
              <Legend visible={false} />
              <Tooltip enabled={true} toolt customizeTooltip={customizeTooltip} />
              <Size height={225} width={250} />
            </PieChart>
            <div style={{ display: 'flex', columnGap: '0.25rem' }}>
              <div style={{ display: 'grid', gridTemplateRows: '1fr 1fr', textAlign: 'center', alignItems: 'center', justifyContent: 'center' }}>
                <div style={{ fontWeight: 700 }}>{caseData.stateCount}</div>
                <div>{'Status'}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="dashboard-panel">
        <PanelHeader title={'Casos novos aguardando atendimento:'} value={caseData.uncategorizedCasesCount} />
        <div style={{ padding: '0 2rem' }}>
          <KpiTable dataSource={caseData.uncategorizedCases} showHeaders={true} columns={caseColumns} isLoadingData={loadingCaseData}></KpiTable>
        </div>
      </div>
      {/* <div className="dashboard-panel">
        <PanelHeader title={'Agentes disponíveis:'} value={agentData.avaliableAgentsCount} />
        <div className="dashboard-panel-chart-container">
          <RingChart isLoading={loadingAgentData} datasource={agentData.agentsByAllocation} palette={['#006C3A', '#5EBD82']} />
        </div>
      </div> */}
      <div className="dashboard-panel" style={{ padding: '0 1rem' }}>
        <div>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', columnGap: '3rem' }}>
            <div>
              <PanelHeader title={'Agentes disponíveis:'} value={agentData.avaliableAgentsCount} />
              <div style={{ paddingTop: '1rem' }}>
                <KpiTable dataSource={agentData.avaliableAgents} showHeaders={false} columns={agentColumns} isLoadingData={loadingAgentData} />
              </div>
            </div>
            <div>
              <PanelHeader title={'Agentes indisponíveis:'} value={agentData.unavaliableAgentsCount} />
              <div style={{ paddingTop: '1rem' }}>
                <KpiTable dataSource={agentData.unavaliableAgents} showHeaders={false} columns={agentColumns} isLoadingData={loadingAgentData} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export { Dashboard };
